export const useSxStyles = () => {
  return {
    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      maxWidth: '450px',
    },
    fieldSet: {
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
    },
    fieldRow: {
      display: 'flex',
      gap: 2,
    },
    dateRange: {
      display: 'flex',
      gap: 2,
      alignItems: 'center',
    },
  };
};
